






















import Vue from 'vue'
import XButton from '@/components/atoms/Button/XButton.vue'
import XIcon from '@/components/atoms/Icon/XIcon.vue'
import XDialog from '@/components/atoms/Dialog/XDialog.vue'
import { ConfirmOptionType } from '@/mixin/confirmMixin'

type DataType = {
  params: ConfirmOptionType | undefined
}

export default Vue.extend({
  name: 'XConfirm',
  components: { XButton, XIcon, XDialog },
  data(): DataType {
    return {
      params: undefined,
    }
  },
  props: {
    name: {
      type: String,
      default: 'XConfirm',
    },
    message: {
      type: String,
      required: true,
    },
  },
  methods: {
    beforeOpen(e: { params: ConfirmOptionType }) {
      this.params = e.params
    },
    onClickCancel() {
      if (this.params !== undefined) {
        this.params.cancelHandler()
      }
      this.$modal.hide(this.name)
    },
    onClickOk() {
      if (this.params !== undefined) {
        this.params.okHandler()
      }
      this.$modal.hide(this.name)
    },
  },
})
